module.exports = __webpack_public_path__ + "static/wishlist1-abc3b9f38e54f896cf6b308a7cc52826.png";